export default {
  name: '白',
  style: {
    color_base: '51, 51, 51',
    color_back_base: '250, 249, 245',
    alpha_slight: '.02'
  }
};
